import Vue from 'vue'
import store from '../../vuex'
import * as restfulService from './restfulService'

function _checkHeimdallToken () {
  return new Promise((resolve, reject) => {
    let token = Vue.cookie.get('heimdall_token')
    if (token) {
      let data = {token}
      let onesignalid = window.localStorage.getItem('onesignalid')
      data.onesignalid = onesignalid
      _login(data)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          reject()
        })
    } else {
      resolve()
    }
  })
}

function _login (data) {
  return new Promise((resolve, reject) => {
    restfulService.post('login', null, null, data)
      .then(loginResponse => {
        if (loginResponse.heimdall_token) {
          Vue.cookie.set('heimdall_token', loginResponse.heimdall_token, {domain: process.env.DOMAIN})
        }
        let nome = loginResponse.usuario.pessoa.nome.split(' ')
        loginResponse.usuario.sigla = nome[0].charAt(0).toUpperCase() + (nome[nome.length - 1].charAt(0).toUpperCase() || '')
        loginResponse.user = loginResponse.usuario
        delete loginResponse.usuario
        store.dispatch('login', loginResponse).then(response => {
          resolve(response)
        })
      })
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

function _logout () {
  return new Promise((resolve, reject) => {
    let token = Vue.cookie.get('heimdall_token')
    let data = {}
    if (token) {
      data.token = token
    }
    restfulService.post('login', 'sair', null, data)
      .then(() => {
        Vue.cookie.delete('heimdall_token', {domain: process.env.DOMAIN})
        store.dispatch('logout').then(() => {
          resolve()
        })
      })
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

export const checkHeimdallToken = _checkHeimdallToken
export const login = _login
export const logout = _logout



// WEBPACK FOOTER //
// ./src/app/services/authService.js